var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascript1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V64H64V0H0ZM34.8275 49.9175C34.8275 56.145 31.1775 58.9825 25.85 58.9825C21.0375 58.9825 18.245 56.4825 16.8275 53.4825L21.725 50.52C22.67 52.195 23.53 53.6125 25.5925 53.6125C27.5675 53.6125 28.815 52.8375 28.815 49.8325V29.3825H34.815L34.8275 49.9175ZM49.05 58.9825C43.465 58.9825 39.8575 56.3175 38.095 52.8375L43 50C44.29 52.105 45.965 53.6525 48.9275 53.6525C51.4275 53.6525 53.01 52.4025 53.01 50.6875C53.01 48.625 51.3775 47.895 48.6275 46.6875L47.1275 46.0425C42.7875 44.195 39.91 41.8775 39.91 36.9775C39.91 32.4775 43.345 29.03 48.7175 29.03C52.54 29.03 55.29 30.3625 57.265 33.8425L52.5825 36.8425C51.5525 34.995 50.435 34.265 48.7175 34.265C46.955 34.265 45.8375 35.3825 45.8375 36.8425C45.8375 38.6475 46.955 39.3775 49.5325 40.495L51.0325 41.1375C56.145 43.33 59.0325 45.5625 59.0325 50.59C59.0175 56.0175 54.765 58.9825 49.05 58.9825Z",
    fill: "#F3E031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript1);
export default __webpack_public_path__ + "static/media/javascript-1.16f3b8d8a592c307c4b4cb270848ff94.svg";
export { ForwardRef as ReactComponent };